import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationBoxComponent } from 'app/components/confirmation-box/confirmation-box.component';
import { DataService } from 'app/data.service';


@Component({
  selector: 'app-view-districts',
  templateUrl: './view-districts.component.html',
  styleUrls: ['./view-districts.component.css']
})
export class ViewDistrictsComponent implements OnInit {

	provincesData:any[];
	districtsData:any[];
	districtName:string;
	districtId:number;
	districtIndex:number;
	status: boolean;
	response: string;

  districtData: FormGroup = new FormGroup({
    province_id: new FormControl('', [Validators.required]),
    district: new FormControl('',[Validators.required])
  })

  constructor(private dataService : DataService, private dialog: MatDialog) { }

  districtFormData: FormGroup = new FormGroup({
    province_id: new FormControl('', [Validators.required]),
    district: new FormControl('',[Validators.required])
  })

  ngOnInit(): void {
  	this.dataService.states()
  		.subscribe((provinces:any) => {
  			this.provincesData = provinces.provinces;
  		});

  	this.dataService.districts()
  		.subscribe((districts:any)=>{
  			this.districtsData = districts.districts;
  		});
  }

  formValue(district,index){
	this.districtFormData.setValue({district: district.district, province_id: district.Province.id})
	console.log(this.districtFormData.value)
  	this.districtName = district.district;
  	this.districtId = district.id;
  	this.districtIndex = index;
  }

  editDistrictData(value){
  	if(this.districtFormData.valid){
		value['province_id'] = value['province_id'].toString()
  		this.dataService.editDistrict(value,this.districtId)
			.subscribe( (response:any) => {
				if(response.status){
					this.response = response.message;
					this.status = response.status;
					this.districtsData.splice(this.districtIndex, 1, response.district);
				}
				else{
					this.response = response.message;
					this.status = response.status;
				}
			});
  	}
  	else{
  		this.response = "Please Change The Value";
  		this.status = false;
  	}
  }

  deleteDistrict(id,index){
	let dialogRef = this.dialog.open(ConfirmationBoxComponent, {
		width: '400px',
		data: {
		  text: 'Are you sure you want to delete this item?'
		}
	})
	dialogRef.afterClosed().subscribe(result => {
		if(result){
			this.dataService.deleteDistrict(id)
				.subscribe((response:any)=>{
					this.districtsData.splice(index,1);
				});
		}
	})
  }

  scroll(el:HTMLElement){
    el.scrollIntoView();
  }

}
